var _excluded = ["children", "className"];
function cov_1xim7nvrc9() {
  var path = "/app/src/components/v2/learn-more-container/learn-more-container.tsx";
  var hash = "3b6bd39ee9e2a81c48d96f97062986038184cc4b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/learn-more-container/learn-more-container.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 34
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 24,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 11,
            column: 35
          }
        },
        loc: {
          start: {
            line: 15,
            column: 13
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3b6bd39ee9e2a81c48d96f97062986038184cc4b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xim7nvrc9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xim7nvrc9();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import cn from 'classnames';
import React from 'react';
import styles from './styles.css';
cov_1xim7nvrc9().s[0]++;
export var LearnMoreContainer = function LearnMoreContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1xim7nvrc9().f[0]++;
  cov_1xim7nvrc9().s[1]++;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.body, className),
    "data-test": "widget-container"
  }, props), children);
};